import script from "./DynamicPerson.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicPerson.vue?vue&type=script&setup=true&lang=js"

import "./DynamicPerson.vue?vue&type=style&index=0&id=40d9e7fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d9e7fa"]])

export default __exports__